import React, { useRef, useState } from "react";
import { ContactStyled } from "./styled";
import HigherOrderComp from "../HigherOrderComp";
import { contactDetail, contactText, description } from "../../content/contact";
import arrowRight from "../../assets/ArrowRight.png";
// import PartnerFormComp from "../PartnerForm";

const ContactUS = () => {

  const cltName = useRef("*****")
  const cltEmail = useRef("*****")
  const cltSubject = useRef("*****")
  const cltCompany = useRef("*****")
  const cltMessage = useRef("*****")
  const [isButtonDistabled, setIsButtonDistabled] = useState(false)
  
  const buttonClicked = () =>{
    let data_send = {}
    data_send["Name"] = cltName.current
    data_send["Email"] = cltEmail.current
    data_send["Subject"] = cltSubject.current
    data_send["Company"] = cltCompany.current
    data_send["Message"] = cltMessage.current
    
    pushToLoki(JSON.stringify(data_send))
    setIsButtonDistabled(true)
  }

async function pushToLoki(DATA) {
  try {
    const url = "https://api.cephlon.tech/common/pushMessage";

    // ---- Create nanosecond timestamp like your Java code ----
    const epochMillis = Date.now(); // ms since epoch
    const nanoAdjustment = Math.floor(performance.now() * 1_000_000) % 1_000_000;
    const epochNanos = (epochMillis * 1_000_000) + nanoAdjustment;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        Accept: "*/*",
        "Content-Type": "application/json",
      },
      body: DATA,
    });

    if (!response.ok) {
      console.log("Loki push failed:", response.status);
    } else {
      // Optional success log
      // console.log("Log pushed to Loki");
    }
  } catch (error) {
    console.log("Exception from pushToLoki:", error);
  }
};


  return (
    <ContactStyled className="website-container">
      <form className="form">
        <div className="text-wrapper">
          <span className="text-gradient">{contactText}</span>
        </div>
        <h2 className="description">{description}</h2>
        <div className="contact-wrapper">
          {contactDetail.map((detail, index) => {
            return <ContactDetail key={index} {...detail} />;
          })}
        </div>
        <div className="field-wrapper">
          <div style={{ display: "flex", gap: "30px", width: "100%" }}>
            <InputField placeholder="Full Name" label="Name" style={{}} onChange={(data)=>{cltName.current = data.target.value}}/>
            <InputField placeholder="Email Address" label="Email" onChange={(data)=>{cltEmail.current = data.target.value}}/>
          </div>
          <InputField
            placeholder="Subjects"
            label="Subjects"
            style={{ maxWidth: "100%" }} onChange={(data)=>{cltSubject.current = data.target.value}}
          />
          <InputField
            placeholder="Brand/Company/Product Name"
            label="Company Name"
            style={{ maxWidth: "100%" }} onChange={(data)=>{cltCompany.current = data.target.value}}
          />
          <div className="input-wrapper" style={{ maxWidth: "100%" }}>
            <label className="input-label">Message</label>
            <textarea
              className="input-field"
              placeholder="Tell us about your project..."
              rows={5}
              onChange={(data)=>{cltMessage.current = data.target.value}}
            />
          </div>
          <div className="gST-wrapper">
            {/* <p>GSTIN 23AARFC5621L1Z9</p> */}
            <button className="submit-btn btn-hover" disabled={isButtonDistabled} onClick={()=>{buttonClicked()}}>
              Send Messages <img src={arrowRight} alt="" />
            </button>
          </div>
        </div>
      </form>
      {/* <PartnerFormComp/> */}
    </ContactStyled>
  );
};

export default HigherOrderComp(ContactUS);

const ContactDetail = ({ iconUrl, title, value }) => {
  return (
    <div className="contact-detail">
      <div>
        <img src={iconUrl} alt={title} />
      </div>
      <div className="detail-wrapper">
        <div className="title">{title} </div>
        <div className="value">{value} </div>
      </div>
    </div>
  );
};

const InputField = ({ style, ...props }) => {
  return (
    <div className="input-wrapper" style={{ ...(style || {}) }}>
      <label className="input-label">{props?.label || "  "}</label>
      <input className="input-field" {...props} />
    </div>
  );
};
